import { addClassAndRemoveElement, getCookie, setCookie, siteLangIsSwedish } from '../utils';

export default function startpageFunctionality() {
  if (!document.querySelector('.front-page-wrapper'))
    return;

  initNewsletterFunctionality();
}

export function initNewsletterFunctionality(isOnFrontPage = true) {
  const popupDOM = {};

  popupDOM.newsletterPopup = document.getElementById('wl-news-letter-popup');
  popupDOM.newsLetterBackdrop = document.getElementById('wl-news-letter-popup__backdrop');
  popupDOM.mailChimpFormContainer = document.getElementById('mc_signup');

  if (!popupDOM.newsletterPopup || !popupDOM.newsLetterBackdrop || !popupDOM.mailChimpFormContainer)
    return;

  popupDOM.mcInputField = document.getElementById('mc_mv_EMAIL');
  popupDOM.privacyCheckBoxContainer = popupDOM.newsletterPopup.querySelector('.privacy-cb');
  popupDOM.privacyCheckBox = popupDOM.privacyCheckBoxContainer.querySelector('input');
  popupDOM.closeBtn = popupDOM.newsletterPopup.querySelector('.newsletter-close-btn');
  popupDOM.mailChimpSubmitBtn = popupDOM.mailChimpFormContainer.querySelector('input[name="mc_signup_submit"]');
  popupDOM.mcSignupSubmitContainer = popupDOM.mailChimpFormContainer.querySelector('.mc_signup_submit');

  popupDOM.cityField = popupDOM.mailChimpFormContainer.querySelector('#mc_mv_CITY');
  popupDOM.countryField = popupDOM.mailChimpFormContainer.querySelector('#mc_mv_COUNTRY');

  popupDOM.privacyCheckBox.addEventListener('change', toggleSubmitBtn.bind(popupDOM.privacyCheckBox, popupDOM));
  popupDOM.newsLetterBackdrop.addEventListener('click', newsletterBackdropEventHandler.bind(null, popupDOM));
  popupDOM.closeBtn.addEventListener('click', newsletterBackdropEventHandler.bind(null, popupDOM));

  adaptPopupHtmlForMailchimpForm(popupDOM);
  addPlaceholderForExtraFields(popupDOM);

  if (isOnFrontPage)
    showNewsletterFormIfCookieNotSet(popupDOM);
}

function addPlaceholderForExtraFields(popupDOM) {
  let cityPlaceHolderStr = 'City';
  let countryPlaceHolderStr = 'Country';

  if ((siteLangIsSwedish())) {
    cityPlaceHolderStr = 'Stad';
    countryPlaceHolderStr = 'Land';
  }

  if (popupDOM.cityField)
    popupDOM.cityField.placeholder = cityPlaceHolderStr;

  if (popupDOM.countryField)
    popupDOM.countryField.placeholder = countryPlaceHolderStr;
}

function showNewsletterFormIfCookieNotSet(popupDOM) {
  const newsletterCookieVersion = '5';
  const newsletterCookieString = 'newsletter_popup_shown_' + newsletterCookieVersion;

  if (!getCookie(newsletterCookieString)) {
    const date = new Date();
    const [month, day, year] = [
      date.getMonth(),
      date.getDate(),
      date.getFullYear()
    ];

    setCookie(newsletterCookieString, `${day}-${month}-${year}`, 60, '/', '.artwood.se', true);
    showNewsLetterAfterDelay(popupDOM);
  }
}

function showNewsLetterAfterDelay(popupDom) {
  setTimeout(() => {
    $(popupDom.newsLetterBackdrop).show();
    $(popupDom.newsletterPopup).show();
  }, 5000);
}

function toggleSubmitBtn(popupDOM) {
  if (this.checked)
    popupDOM.mailChimpSubmitBtn.disabled = false;
  else
    popupDOM.mailChimpSubmitBtn.disabled = true;
}

function adaptPopupHtmlForMailchimpForm(popupDOM) {
  popupDOM.mailChimpSubmitBtn.classList.add(...['wl-button', 'wl-class-added']);
  popupDOM.mailChimpSubmitBtn.disabled = true;

  if ((siteLangIsSwedish())) {
    popupDOM.mailChimpSubmitBtn.value = 'FÖLJ OSS';
    popupDOM.mcInputField.placeholder = 'E-mail adress';
  } else {
    popupDOM.mailChimpSubmitBtn.value = 'FOLLOW US';
    popupDOM.mcInputField.placeholder = 'E-mail address';
  }

  // Flytta in checkboxen in i formuläret som skapats av mailchimp
  popupDOM.mcSignupSubmitContainer.before(popupDOM.privacyCheckBoxContainer);
  popupDOM.privacyCheckBoxContainer.classList.add('wl-moved');
}

function newsletterBackdropEventHandler(popupDOM) {
  addClassAndRemoveElement(popupDOM.newsletterPopup, 300);
  addClassAndRemoveElement(popupDOM.newsLetterBackdrop, 300);
}
